/**
 * @file This file contains configurations for reusable audio effects.
 * @module audioEffectsConfig
 */

/**
 * @typedef {Object} AudioEffect
 * @property {'reverb'|'filter'|'chain'} type - The type of the effect.
 * @property {string} [impulseResponse] - URL for the reverb impulse response file.
 * @property {'lowpass'|'highpass'|'bandpass'} [filterType] - The type of filter.
 * @property {number} [frequency] - The cutoff frequency for the filter.
 * @property {number} [q] - The quality factor for the filter.
 * @property {AudioEffect[]} [nodes] - An array of effect nodes for a 'chain' type effect.
 */

export const audioEffectsConfig = {
    'chatter': {
        type: 'reverb',
        impulseResponse: 'assets/sounds/impulse/small-room.wav',
    },
    'muffled': {
        type: 'filter',
        filterType: 'lowpass',
        frequency: 500, // Cut off frequencies above 500 Hz
        q: 1,
    },
    'distantHall': {
        type: 'chain',
        nodes: [
            {
                type: 'reverb',
                impulseResponse: 'assets/sounds/impulse/large-hall.wav',
            },
            { type: 'filter', filterType: 'lowpass', frequency: 1200, q: 0.7 }
        ]
    },
    'otherRoom': {
        type: 'chain',
        nodes: [
            {
                type: 'reverb',
                impulseResponse: 'assets/sounds/impulse/small-room.wav',
            },
            { type: 'filter', filterType: 'lowpass', frequency: 300, q: 0.7 }
        ]
    }
};